import React, { useEffect, useState } from "react";
import { Divider, Card, Skeleton } from 'antd';
import axios from "axios";
import { Link } from "react-router-dom";
import "../css/home.css"



const { Meta } = Card;

const HomesMovies = () => {

    let [dataMovi, setDataMovi] = useState([])
    let [loadingStatus, setLoadingStatus] = useState(true)

    useEffect (() => {

    
    let getData = async () =>{
    let resultMovie = await axios.get('https://backendexample.sanbersy.com/api/data-movie')
    setDataMovi([...resultMovie.data])
    setLoadingStatus(false)
}

    getData ()

}, [loadingStatus, setLoadingStatus])

let handleText = (param) => {
    if (param === undefined) {
        return "" }
        else{
            return(
            param.slice(0, 20) + "...")
        }
    }
    let SkeletonComponent = () => {
    return (<Card
    hoverable
    style={{ width : 240}}
    cover={<Skeleton.Image style={{width: 240}} />}>
<Skeleton/>
</Card>)
    }

    return (
        <div>
            <Divider style={{color: "white", fontSize: "45px", fontWeight: "bold", textAlign: "center", marginTop: "80px"}}> Movies</Divider>
            <div style={{backgroundColor:"black", color:"white"}} className="container-home">
                
                {loadingStatus && <SkeletonComponent/>
                }

                {dataMovi !== null && (
                <>
                {dataMovi.map((res, index) => {
                    return (
            <Link key={index} to={`/movie/${res.id}`}>
            <Card
            key={index}
             hoverable
             style={{ width: 240, padding:"20px" }}
             cover={<img alt="Movies" src={res.image_url} width={250} height={250} />}> 
           
            <Meta title={res.title} description={handleText(res.description)} />
        </Card> 
        </Link>

                    )
                })}
                </>
            )}
            
            
            </div>
        </div>
    )}

export default HomesMovies